



















import { Component, Vue, Prop } from 'vue-property-decorator'
import { TakeOtherAction } from '@/class/game'
import Player from './Player.vue'

@Component({
  components: {
    Player
  }
})
export default class ReplayTakeOther extends Vue {
  @Prop() takeOtherAction!: TakeOtherAction;

  get actors () {
    return Object.values(this.takeOtherAction.players).filter(p => p.takeOther)
  }

  getPlayer (playerId: string) {
    return this.takeOtherAction.players[playerId]
  }
}
